
import ActionSummary from 'components/Actions/ActionSummary.vue'
import dialogMethods from 'src/mixins/dialogMethods'
export default {
  name: 'ActionCreate',

  mixins: [dialogMethods],

  props: {
    choise: { type: Object, required: true },
    questions: { type: Array, required: true },
  },

  data() {
    return {
      current: [],
      dismiss: null,
      step: 0,
      actions: [
        { label: 'Telefonata', value: 'Telefonata' },
        { label: 'SMS', value: 'SMS' },
      ],

      results: [],
    }
  },

  computed: {
    stepConf() {
      return index => ({
        name: index,
        prefix: index + 1,
        done: this.isDone(index),
        headerNav: this.isDone(index) || this.isDone(index - 1),
      })
    },

    isLastStep() {
      return this.step === this.questions.length - 1
    },

    isSetted() {
      return value => typeof value === 'boolean' || value.length > 0
    },

    isDone() {
      return step => this.results[step] ? this.isSetted(this.results[step].value) : false
    },
    // editing () {
    //   return index => this.results[index] && (this.results[index].value !== this.current[index])
    // }
  },

  methods: {
    // eslint-disable-next-line vue/no-unused-properties
    show() {
      for (const [index, { multiple, radio }] of this.questions.entries())
        this.$set(this.current, index, multiple ? [] : (radio ? false : ''))

      this.$refs.dialog.show()
      this.showStatus()
    },

    hide() {
      this.dismiss()
      this.$refs.dialog.hide()
    },

    onOKClick() {
      this.$emit('ok', { results: this.results, target: this.choise.value })
      this.hide()
    },

    forward() {
      const value = this.current[this.step]
      if (this.isSetted(value)) {
        this.$set(this.results, this.step, {
          text: this.questions[this.step].text,
          question: this.questions[this.step].question,
          value,
          // index: this.step
        })
        if (this.isLastStep) this.onOKClick()
        else this.$refs.stepper.next()
      }
    },

    showStatus() {
      this.dismiss = this.$q.dialog({
        component: ActionSummary,
        results: this.results,
      }).hide
    },
  },
}
